<template>
  <div class="menu-item-wrapper">
    <div class="menu-top">
      <div class="menu-top-icon" style="float: left; ">
        <v-icon :color="$vuetify.theme.themes[theme].text" v-if="!$store.state.menuOpen" @click="openMenu()">menu</v-icon>
        <v-icon :color="$vuetify.theme.themes[theme].text" v-if="$store.state.menuOpen" @click="closeMenu()">chevron_left</v-icon>
      </div>
      <div v-if="$store.state.menuOpen" :style="{color: $vuetify.theme.themes[theme].text}" style="float: left; font-size: 24px; padding: 7px 0; font-weight: bold; font-family: 'Sofia Pro', sans-serif;">pillarrr.io</div>
    </div>

    <div class="nav-scroll" :class="userRole">

      <router-link :to="`/account`" custom v-slot="{ navigate }">
        <div class="menu-user-info" @click="navigate" style="cursor: pointer;">
          <v-list flat two-line dense class="ma-0 pa-0" style="background: none;">
            <v-list-item
              class="ma-0 pa-0"
            >
            <span v-if="companyCallcenter">
              <v-badge
                v-if="$store.state.userCallCenterOnline"
                color="success"
                avatar
                icon="phone"
                overlap
                >
                <v-avatar class="my-0"  size="44" :color="companyPrimaryColor">
                  <span class="white--text headline">{{ userAbb }}</span>
                </v-avatar>
              </v-badge>
              <v-badge
                v-else
                color="error"
                avatar
                icon="phone"
                overlap
                >
                <v-avatar class="my-0"  size="44" :color="companyPrimaryColor">
                  <span class="white--text headline">{{ userAbb }}</span>
                </v-avatar>
              </v-badge>
            </span>

              <v-avatar v-else class="my-0"  size="44" :color="companyPrimaryColor">
                <span class="white--text headline">{{ userAbb }}</span>
              </v-avatar>
              
              <v-list-item-content class="ml-4">
                <v-list-item-title :style="{color: $vuetify.theme.themes[theme].text}" style="font-weight: bold;" >{{userFirstName}} {{userLastName}}</v-list-item-title>
                <v-list-item-subtitle :style="{color: $vuetify.theme.themes[theme].text}" >{{ userCompanyName }}</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-icon >
                <v-icon class="mt-3" :color="$vuetify.theme.themes[theme].text">settings</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </div>
      </router-link>

      <router-link :to="`/home`" custom v-slot="{ navigate }">
        <div class="menu-group first small" @click="navigate">
          <div class="menu-group-summary">
            <div class="menu-group-summary-icon">
              <v-icon :color="$vuetify.theme.themes[theme].text">home</v-icon>
            </div>
            <div class="menu-group-summary-text">
              <p class="menu-group-name">Home</p>
            </div>
            <div class="menu-group-expand"></div>
          </div>
        </div>
      </router-link>

      <router-link :to="`/barometers`" custom v-slot="{ navigate }" v-if="(!demoMode && companyBarometers == true) || userRole == 'superadmin'" >
        <div class="menu-group small" @click="navigate">
          <div class="menu-group-summary">
            <div class="menu-group-summary-icon">
              <v-icon :color="$vuetify.theme.themes[theme].text">speed</v-icon>
            </div>
            <div class="menu-group-summary-text">
              <p class="menu-group-name">Barometers</p>
            </div>
            <div class="menu-group-expand"></div>
          </div>
        </div>
      </router-link>

      <!-- <router-link tag="div" class="menu-group small"  v-if="userCompany == 'hairbeautycompany' || userRole == 'superadmin'" :to="`/prijslijst`">
        <div class="menu-group-summary">
          <div class="menu-group-summary-icon">
            <v-icon>attach_money</v-icon>

          </div>
          <div class="menu-group-summary-text">
            <p class="menu-group-name">Prijslijst</p>
          </div>
          <div class="menu-group-expand"></div>
        </div>
      </router-link> -->

      <router-link :to="`/relevantcasting`" custom v-slot="{ navigate }" v-if="!demoMode && (((companyNarrowcasting == true && userRole === 'manager') && (companyNarrowcasting == true && userRole === 'admin')) || userRole == 'superadmin')">
        <div class="menu-group small" @click="navigate">
          <div class="menu-group-summary">
            <div class="menu-group-summary-icon">
              <v-icon :color="$vuetify.theme.themes[theme].text">tv</v-icon>
            </div>
            <div class="menu-group-summary-text">
              <p class="menu-group-name">Relevantcasting</p>
            </div>
            <div class="menu-group-expand"></div>
          </div>
        </div>
      </router-link>

      <!-- / Competentie systeem \ -->

      <div class="menu-group" :class="{ 'collapsed': menuCompetentionCollapsed}"  v-if="(userRole == 'superadmin' && !demoMode) || (userRole == 'admin' && userCompany == 'hairbeautycompany') || (userRole == 'manager' && userCompany == 'hairbeautycompany') ">
        <div class="menu-group-summary" @click="clickMenuItemCompetention()">
          <div class="menu-group-summary-icon">
            <v-icon :color="$vuetify.theme.themes[theme].text">check_box</v-icon>
          </div>
          <div class="menu-group-summary-text">
            <p class="menu-group-name">Competenties</p>
            <p class="menu-group-summary-items">Overzicht en Instellingen</p>
          </div>
          <div class="menu-group-expand">
            <v-icon :color="$vuetify.theme.themes[theme].text" v-if="menuCompetentionCollapsed && $store.state.menuOpen">keyboard_arrow_down</v-icon>
            <v-icon :color="$vuetify.theme.themes[theme].text" v-else-if="!menuCompetentionCollapsed && $store.state.menuOpen">keyboard_arrow_down</v-icon>
            <v-icon :color="$vuetify.theme.themes[theme].text" v-else>keyboard_arrow_right</v-icon>
          </div>
        </div>

        <div class="menu-group-items-wrapper">
          <div class="menu-group-items">
            <div class="menu-mobile-header" v-if="!$store.state.menuOpen">Competenties</div>
            <span v-if="userRole == 'admin' || userRole == 'superadmin'" @click="closeMenuExtentions();">
              <router-link :to="`/competenties-overzicht`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text" small>view_week</v-icon>
                  </div>
                  <div class="menu-item-text">Overzicht</div>
                </div>
              </router-link>
            </span>

             <span @click="closeMenuExtentions();">
              <router-link :to="`/competenties-planning`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text" small>today</v-icon>
                  </div>
                  <div class="menu-item-text">Financiele planning</div>
                </div>
              </router-link>
            </span>

             <span v-if="userRole == 'admin' || userRole == 'superadmin'" @click="closeMenuExtentions();">
               <router-link :to="`/competenties-dossier`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text" small>description</v-icon>
                  </div>
                  <div class="menu-item-text">Dossiers</div>
                </div>
              </router-link>
            </span>

            <span v-if="userRole == 'admin' || userRole == 'superadmin'" @click="closeMenuExtentions();">
              <router-link :to="`/competenties-instellingen`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text" small>settings</v-icon>
                  </div>
                  <div class="menu-item-text">Instellingen</div>
                </div>
              </router-link>
            </span>

          </div>
        </div>
      </div>

      <!-- \ Competentie systeem / -->

      <!-- / Widget \ -->

      <div class="menu-group" :class="{ 'collapsed': menuWidgetCollapsed}"  v-if="userRole == 'admin' || userRole == 'manager' || userRole == 'superadmin'">
        <div class="menu-group-summary" @click="clickMenuItemWidget()">
          <div class="menu-group-summary-icon">
            <v-icon :color="$vuetify.theme.themes[theme].text">today</v-icon>
          </div>
          <div class="menu-group-summary-text">
            <p class="menu-group-name">Afspraakwidget</p>
            <p class="menu-group-summary-items">Instellingen en Statistieken</p>
          </div>
          <div class="menu-group-expand">
            <v-icon :color="$vuetify.theme.themes[theme].text" v-if="menuWidgetCollapsed && $store.state.menuOpen">keyboard_arrow_down</v-icon>
            <v-icon :color="$vuetify.theme.themes[theme].text" v-else-if="!menuWidgetCollapsed && $store.state.menuOpen">keyboard_arrow_down</v-icon>
            <v-icon :color="$vuetify.theme.themes[theme].text" v-else>keyboard_arrow_right</v-icon>
          </div>
        </div>

        <div class="menu-group-items-wrapper">
          <div class="menu-group-items">
            <div class="menu-mobile-header" v-if="!$store.state.menuOpen">Afspraakwidget</div>
            <span @click="closeMenuExtentions()">
              <router-link :to="`/widget-statistieken`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text" small>bar_chart</v-icon>
                  </div>
                  <div class="menu-item-text">Statistieken</div>
                </div>
              </router-link>
            </span>
            <span @click="closeMenuExtentions()">
              <router-link :to="`/widget-reports`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text" small>mdi-chart-areaspline-variant</v-icon>
                  </div>
                  <div class="menu-item-text">Rapporten</div>
                </div>
              </router-link>
            </span>
            <span @click="closeMenuExtentions()">
              <router-link :to="`/surveys`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text" small>message_question</v-icon>
                  </div>
                  <div class="menu-item-text">Survey</div>
                </div>
              </router-link>
            </span>
            <span @click="closeMenuExtentions()" v-if="userCompany == 'beautybyroos' || userRole == 'superadmin'"> 
              <router-link :to="`/mautic-lijsten`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text" small>mdi-phone-outgoing</v-icon>
                  </div>
                  <div class="menu-item-text">Mautic lijsten</div>
                </div>
              </router-link>
            </span>
            <span @click="closeMenuExtentions()">
              <router-link :to="`/widget-instellingen`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text" small>settings</v-icon>
                  </div>
                  <div class="menu-item-text">Instellingen</div>
                </div>
              </router-link>
            </span>
          </div>
        </div>
      </div>

      <!-- \ Widget / -->
      
      <!-- / Klant Reviews \ -->

      <div class="menu-group" :class="{ 'collapsed': menuReviewsCollapsed}"  v-if="userRole == 'superadmin' || (companyJourney == true && (userRole === 'admin' || userRole === 'manager' || userPermissions.showJourneyData == true))">
        <div class="menu-group-summary" @click="clickMenuItemReviews()">
          <div class="menu-group-summary-icon">
            <v-icon :color="$vuetify.theme.themes[theme].text">star_half</v-icon>
          </div>
          <div class="menu-group-summary-text">
            <p class="menu-group-name">Reviews</p>
            <p class="menu-group-summary-items">Vragenlijsten, Resultaten, Verbeteringen, Klanten, Digitale bon, Instellingen</p>
          </div>
          <div class="menu-group-expand">
            <v-icon :color="$vuetify.theme.themes[theme].text" v-if="menuReviewsCollapsed && $store.state.menuOpen">keyboard_arrow_down</v-icon>
            <v-icon :color="$vuetify.theme.themes[theme].text" v-else-if="!menuReviewsCollapsed && $store.state.menuOpen">keyboard_arrow_down</v-icon>
            <v-icon :color="$vuetify.theme.themes[theme].text" v-else>keyboard_arrow_right</v-icon>
          </div>
        </div>
        <div class="menu-group-items-wrapper">
          <div class="menu-group-items">
            <div class="menu-mobile-header" v-if="!$store.state.menuOpen">Reviews</div>
            <span v-if="userRole === 'superadmin'|| (companyJourney == true && userRole === 'admin' || userPermissions.journeyViewJourney == true || userPermissions.journeyEditQuestions == true || userPermissions.journeyEditJourney == true)" @click="closeMenuExtentions()">
              <router-link :to="`/journeys`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text" small>chat</v-icon>
                  </div>
                  <div class="menu-item-text">Vragenlijsten</div>
                </div>
              </router-link>
            </span>

            <span @click="closeMenuExtentions()">
              <router-link :to="`/journey-results`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text" small >bar_chart</v-icon>
                  </div>
                  <div class="menu-item-text">Resultaten</div>
                </div>
              </router-link>
            </span>

            <span @click="closeMenuExtentions()">
              <router-link :to="`/journey-improvements`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text" small>trending_up</v-icon>
                  </div>
                  <div class="menu-item-text">Verbeteringen</div>
                </div>
              </router-link>
            </span>

            <span @click="closeMenuExtentions()">
              <router-link :to="`/clients`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text" small>face</v-icon>
                  </div>
                  <div class="menu-item-text">Klanten</div>
                </div>
              </router-link>
            </span>

            <span v-if="(userRole === 'manager' || userRole === 'admin') || userRole == 'superadmin'" @click="closeMenuExtentions()">
              <router-link :to="`/kassabonnen`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text" small >receipt</v-icon>
                  </div>
                  <div class="menu-item-text">Digitale bon</div>
                </div>
              </router-link>
            </span>

            <span @click="closeMenuExtentions()">
              <router-link :to="`/reviews-instellingen`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text" small>settings</v-icon>
                  </div>
                  <div class="menu-item-text">Instellingen</div>
                </div>
              </router-link>
            </span>
          </div>
        </div>
      </div>

      <!-- \ Klant Reviews / -->

      <!-- / Klantdossier \ -->

      <div class="menu-group" :class="{ 'collapsed': menuDossierCollapsed}"  v-if="companyDossier == true || userRole == 'superadmin'">
        <div class="menu-group-summary" @click="clickMenuItemDossier()">
          <div class="menu-group-summary-icon">
            <v-icon :color="$vuetify.theme.themes[theme].text">loyalty</v-icon>
          </div>
          <div class="menu-group-summary-text">
            <p class="menu-group-name">Dossier</p>
            <p class="menu-group-summary-items">Dossiers, Foto's en Wachtlijst</p>
          </div>
          <div class="menu-group-expand">
            <v-icon :color="$vuetify.theme.themes[theme].text" v-if="menuReviewsCollapsed && $store.state.menuOpen">keyboard_arrow_down</v-icon>
            <v-icon :color="$vuetify.theme.themes[theme].text" v-else-if="!menuReviewsCollapsed && $store.state.menuOpen">keyboard_arrow_down</v-icon>
            <v-icon :color="$vuetify.theme.themes[theme].text" v-else>keyboard_arrow_right</v-icon>
          </div>
        </div>

        <div class="menu-group-items-wrapper">
          <div class="menu-group-items">
            <div class="menu-mobile-header" v-if="!$store.state.menuOpen">Dossiers</div>
            <span @click="closeMenuExtentions()">
              <router-link :to="`/dossier`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text" small>inbox</v-icon>
                  </div>
                  <div class="menu-item-text">Dossiers</div>
                </div>
              </router-link>
            </span>

            <span v-if="companyDossierPhotos == true || userRole == 'superadmin'" @click="closeMenuExtentions()">
              <router-link :to="`/photowall`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text" small>burst_mode</v-icon>
                  </div>
                  <div class="menu-item-text">
                    <v-badge
                      class="align-self-center"  
                      top r
                      ight 
                      v-model="showBatchPhotos"
                      color="#FF5252"
                      >
                      <template v-slot:badge>
                        <span class="white--text">{{clientPhotos.length}}</span>
                      </template>
                      <span :style="{color: $vuetify.theme.themes[theme].text}">Foto's</span>
                    </v-badge>
                  </div>
                </div>
              </router-link>
            </span>

            <span @click="closeMenuExtentions()" v-if="userCompany == 'beautybyroos' || userRole == 'superadmin'">
              <router-link :to="`/abonnementen`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text" small>mdi-file-plus</v-icon>
                  </div>
                  <div class="menu-item-text">Abonnementen</div>
                </div>
              </router-link>
            </span>

            <span @click="closeMenuExtentions()" v-if="(userCompany == 'beautybyroos' && (userRole == 'manager' || userRole == 'admin')) || userRole == 'superadmin'">
              <router-link :to="`/toestemmingen`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text" small>mdi-checkbox-marked</v-icon>
                  </div>
                  <div class="menu-item-text">Toestemmingsformulieren</div>
                </div>
              </router-link>
            </span>

            <span @click="closeMenuExtentions()" v-if="(userCompany == 'beautybyroos' && (userRole == 'manager' || userRole == 'admin')) || userRole == 'superadmin'">
              <router-link :to="`/klachten`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text" small>mdi-emoticon-sad</v-icon>
                  </div>
                  <div class="menu-item-text">Klachtenformulieren</div>
                </div>
              </router-link>
            </span>

            <span @click="closeMenuExtentions()" v-if="(userCompany == 'beautybyroos' && (userRole == 'manager' || userRole == 'admin')) || userRole == 'superadmin'">
              <router-link :to="`/medical-intake`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text" small>mdi-medical-bag</v-icon>
                  </div>
                  <div class="menu-item-text">Medische intake</div>
                </div>
              </router-link>
            </span>

            <span @click="closeMenuExtentions()">
              <router-link :to="`/clientqueue`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-badge
                      class="align-self-center"  top right overlap
                      v-model="showBatchQueue"
                      color="#FF5252" 
                      >
                      <template v-slot:badge>
                        <span class="white--text">{{clientQueue.length}}</span>
                      </template>
                      <v-icon :color="$vuetify.theme.themes[theme].text" small>queue</v-icon>
                    </v-badge>
                  </div>
                  <div class="menu-item-text">Wachtlijst</div>
                </div>
              </router-link>
            </span>

            <span @click="closeMenuExtentions()">
              <router-link :to="`/online-afspraken`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">    
                    <v-icon :color="$vuetify.theme.themes[theme].text" small>phonelink</v-icon>
                  </div>
                  <div class="menu-item-text">Afspraken zonder klantenkaart</div>
                </div>
              </router-link>
            </span>

            <span v-if="userRole == 'superadmin'" @click="closeMenuExtentions()">
              <router-link :to="`/piggysocial`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">    
                    <v-icon :color="$vuetify.theme.themes[theme].text" small>plus_one</v-icon>
                  </div>
                  <div class="menu-item-text">Piggy Social Spaarders</div>
                </div>
              </router-link>
            </span>

          </div>
        </div>
      </div>

      <!-- \ Klantdossier / -->

      <!-- / SMS  \ -->
      <div class="menu-group" :class="{ 'collapsed': menuMessagesCollapsed}"  v-if="companySms == true || userRole == 'superadmin'">
        <div class="menu-group-summary" @click="clickMenuItemMessages()">
          <div class="menu-group-summary-icon">
            <v-icon :color="$vuetify.theme.themes[theme].text">message</v-icon>
          </div>
          <div class="menu-group-summary-text">
            <p class="menu-group-name">SMS-berichten</p>
            <p class="menu-group-summary-items">Instellingen en Statistieken</p>
          </div>
          <div class="menu-group-expand">
            <v-icon :color="$vuetify.theme.themes[theme].text" v-if="menuMessagesCollapsed && $store.state.menuOpen">keyboard_arrow_down</v-icon>
            <v-icon :color="$vuetify.theme.themes[theme].text" v-else-if="!menuMessagesCollapsed && $store.state.menuOpen">keyboard_arrow_down</v-icon>
            <v-icon :color="$vuetify.theme.themes[theme].text" v-else>keyboard_arrow_right</v-icon>
          </div>
        </div>

        <div class="menu-group-items-wrapper">
          <div class="menu-group-items">
            <div class="menu-mobile-header" v-if="!$store.state.menuOpen">SMS-berichten</div>

            <span @click="closeMenuExtentions()">
              <router-link :to="`/sms-berichten`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text" small>bar_chart</v-icon>
                  </div>
                  <div class="menu-item-text">Statistieken</div>
                </div>
              </router-link>
            </span>

            <span @click="closeMenuExtentions()" v-if="userRole == 'admin'|| userRole == 'superadmin'">
              <router-link :to="`/sms-berichten-instellingen`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text" small>settings</v-icon>
                  </div>
                  <div class="menu-item-text">Instellingen</div>
                </div>
              </router-link>
            </span>
          </div>
        </div>
      </div>
      <!-- \ SMS  / -->

      <!-- / Admin \ -->

      <div class="menu-group" :class="{ 'collapsed': menuAdminCollapsed}"  v-if=" userRole == 'superadmin' && !demoMode">
        <div class="menu-group-summary" @click="clickMenuItemAdmin()">
          <div class="menu-group-summary-icon">
            <v-icon :color="$vuetify.theme.themes[theme].text">build</v-icon>
          </div>
          <div class="menu-group-summary-text">
            <p class="menu-group-name">Onderhoud</p>
            <p class="menu-group-summary-items">Bedrijven, Gebruikers en Logs</p>
          </div>
          <div class="menu-group-expand">
            <v-icon :color="$vuetify.theme.themes[theme].text" v-if="menuReviewsCollapsed && $store.state.menuOpen">keyboard_arrow_down</v-icon>
            <v-icon :color="$vuetify.theme.themes[theme].text" v-else-if="!menuReviewsCollapsed && $store.state.menuOpen">keyboard_arrow_down</v-icon>
            <v-icon :color="$vuetify.theme.themes[theme].text" v-else>keyboard_arrow_right</v-icon>
          </div>
        </div>

        <div class="menu-group-items-wrapper">
          <div class="menu-group-items">
            <div class="menu-mobile-header" v-if="!$store.state.menuOpen">Onderhoud</div>
            <span @click="closeMenuExtentions()">
              <router-link :to="`/companies`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text" small>business</v-icon>
                  </div>
                  <div class="menu-item-text">Bedrijven</div>
                </div>
              </router-link>
            </span>

            <span @click="closeMenuExtentions()">
              <router-link :to="`/users`" custom v-slot="{ navigate }">
                <div class="menu-group-item clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text" small>person</v-icon>
                  </div>
                  <div class="menu-item-text">Gebruikers</div>
                </div>
              </router-link>
            </span>
            
            <span @click="closeMenuExtentions()">
              <router-link :to="`/log`" custom v-slot="{ navigate }">
                <div class="menu-group-item last clear" @click="navigate">
                  <div class="menu-item-icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text" small>notes</v-icon>
                  </div>
                  <div class="menu-item-text">Log</div>
                </div>
              </router-link>
            </span>
      
          </div>
        </div>
      </div>

      <!-- \ Admin  / -->

      
    </div>

    <div class="nav-fixed-buttom" :class="userRole">
      <div v-if="userRole === 'superadmin'" style="height: 40px;" class="text-center">
        <v-btn v-if="!demoMode" icon color="text" @click="setDemoMode(true)">
          <v-icon>play_arrow</v-icon>
        </v-btn>

        <v-btn v-if="demoMode" icon color="text" @click="setDemoMode(false)">
          <v-icon color="#FF4500">stop</v-icon>
        </v-btn>
      </div>
  
      <div style="height: 40px;" class="text-center">
        <v-tooltip right  v-if="theme == 'light'" >
          <template v-slot:activator="{ on }"> 
            <v-btn v-on="on" icon @click="setDarkTheme(true) ">
              <v-icon color="text">brightness_7</v-icon>
            </v-btn>
          </template>
          <span class="white--text">Applicatie weergeven in Darkmode</span>
        </v-tooltip>

        <v-tooltip right  v-if="theme == 'dark'">
          <template v-slot:activator="{ on }"> 
            <v-btn v-on="on"  icon color="text" @click="setDarkTheme(false)">
              <v-icon color="text">brightness_4</v-icon>
            </v-btn>
          </template>
          <span class="white--text">Applicatie weergeven in Lightmode</span>
        </v-tooltip>
      </div>
        

      <!-- <v-btn  @click="$vuetify.theme.dark = true">Dark</v-btn> -->
      <span v-if="userRole === 'superadmin' || userRole === 'admin' || userRole === 'manager'">
        <router-link :to="`/algemene-instellingen`" custom v-slot="{ navigate }">
          <div class="menu-group first small" @click="navigate">
            <div class="menu-group-summary">
              <div class="menu-group-summary-icon">
                <v-icon size="18px" :color="$vuetify.theme.themes[theme].text" >settings</v-icon>
              </div>
              <div class="menu-group-summary-text">
                <p class="menu-group-name">Instellingen</p>
              </div>
              <div class="menu-group-expand"></div>
            </div>
          </div>
        </router-link>
      </span>

      <div class="menu-group small logout" :class="{ 'first' : userRole == 'employee'}" @click="logout()">
        <div class="menu-group-summary">
          <div class="menu-group-summary-icon">
            <v-icon size="18px" :color="$vuetify.theme.themes[theme].text" >lock</v-icon>
          </div>
          <div class="menu-group-summary-text">
            <p class="menu-group-name">Uitloggen</p>
          </div>
          <div class="menu-group-expand"></div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import lodash from "lodash";
import moment from "moment";
import { bus } from "../../main";
import db from "../../firebase/init";

export default {
  name: "Sidemenu",
  data: () => ({
    mini: true,
    showBatchQueue: false,
    showBatchPhotos: false,
    selectedBranches: [],
    clientQueue: [],
    clientPhotos: [],
    menuReviewsCollapsed: true,
    menuDossierCollapsed: true,
    menuAdminCollapsed: true,
    menuWidgetCollapsed: true,
    menuMessagesCollapsed: true,
    menuCompetentionCollapsed: true,
  }),

  created(){
    this.loadBranches()
    bus.$on("loadCompanyQueue", startDate =>{
      this.countQueueClients();
    })
     // Remember menu openings choice in Local Storage
    if(window.localStorage.getItem('menuCollapsed') == 'true'){
      this.$store.dispatch("menuStatus", false);
    } 
    else {
      window.localStorage.setItem('menuCollapsed', false);
      this.$store.dispatch("menuStatus", true);
    }

    // Remember pillarrrDarkmode choice in Local Storage
    if(window.localStorage.getItem('pillarrrDarkmode') == 'true'){
      this.setDarkTheme(true);
    } 
    else {
      window.localStorage.setItem('pillarrrDarkmode', false);
      this.setDarkTheme(false);
    }

    // Remember pillarrrDarkmode choice in Local Storage
    if(window.localStorage.getItem('pillarrrDemoMode') == 'true'){
      this.$store.dispatch("demoMode", true);
    } 
    else {
      window.localStorage.setItem('pillarrrDemoMode', false);
      this.$store.dispatch("demoMode", false);
    }
  },

  methods: {
    openMenu() {
      this.$store.dispatch("menuStatus", true);
      window.localStorage.setItem('menuCollapsed', false);
    },

    closeMenu() {
      this.$store.dispatch("menuStatus", false);
      window.localStorage.setItem('menuCollapsed', true);
      this.menuReviewsCollapsed = true;
      this.menuDossierCollapsed = true;
      this.menuAdminCollapsed = true;
      this.menuWidgetCollapsed = true;
      this.menuCompetentionCollapsed = true;
    },

    closeMenuExtentions(){
      // Close submenu layover when menu is collapsed
      if(!this.$store.state.menuOpen){
        this.menuReviewsCollapsed = true;
        this.menuDossierCollapsed = true;
        this.menuAdminCollapsed = true;
        this.menuWidgetCollapsed = true;
        this.menuCompetentionCollapsed = true;
      }
    },

    setDarkTheme(value){
      this.$vuetify.theme.dark = value
      window.localStorage.setItem('pillarrrDarkmode', value);
    },

    setDemoMode(value){
      window.localStorage.setItem('pillarrrDemoMode', value);
      this.$store.dispatch("demoMode", value);
    },

    clickMenuItemMessages(){
      if(this.menuMessagesCollapsed == true){
        this.menuMessagesCollapsed = false;
        if(!this.$store.state.menuOpen){
          this.menuReviewsCollapsed = true;
          this.menuDossierCollapsed = true;
          this.menuAdminCollapsed = true;
          this.menuCompetentionCollapsed = true;
          this.menuWidgetCollapsed = true;
        }
      } else{
        this.menuMessagesCollapsed = true;
      }
    },
    clickMenuItemWidget(){
      if(this.menuWidgetCollapsed == true){
        this.menuWidgetCollapsed = false;
        if(!this.$store.state.menuOpen){
          this.menuReviewsCollapsed = true;
          this.menuDossierCollapsed = true;
          this.menuAdminCollapsed = true;
          this.menuCompetentionCollapsed = true;
        }
      } else{
        this.menuWidgetCollapsed = true;
      }
    },

    clickMenuItemCompetention(){
      if(this.menuCompetentionCollapsed == true){
        this.menuCompetentionCollapsed = false;
        if(!this.$store.state.menuOpen){
          this.menuReviewsCollapsed = true;
          this.menuDossierCollapsed = true;
          this.menuAdminCollapsed = true;
          this.menuWidgetCollapsed = true;
          this.menuMessagesCollapsed = true;
        }
      } else{
        this.menuCompetentionCollapsed = true;
        
      }
    },

    clickMenuItemReviews(){
      if(this.menuReviewsCollapsed == true){
        this.menuReviewsCollapsed = false;
        if(!this.$store.state.menuOpen){
          this.menuDossierCollapsed = true;
          this.menuAdminCollapsed = true;
          this.menuWidgetCollapsed = true;
          this.menuMessagesCollapsed = true;
          this.menuCompetentionCollapsed = true;
        }
      } else{
        this.menuReviewsCollapsed = true;
      }
    },

    
    clickMenuItemDossier(){
      if(this.menuDossierCollapsed == true){
        this.menuDossierCollapsed = false;
        if(!this.$store.state.menuOpen){
          this.menuReviewsCollapsed = true
          this.menuAdminCollapsed = true;
          this.menuWidgetCollapsed = true;
          this.menuMessagesCollapsed = true;
          this.menuCompetentionCollapsed = true;
        }
      } else{
        this.menuDossierCollapsed = true;
      }
    },

    clickMenuItemAdmin(){
      if(this.menuAdminCollapsed == true){
        this.menuAdminCollapsed = false;
        if(!this.$store.state.menuOpen){
          this.menuReviewsCollapsed = true;
          this.menuDossierCollapsed = true;
          this.menuWidgetCollapsed = true;
          this.menuMessagesCollapsed = true;
          this.menuCompetentionCollapsed = true;
        }
      } else{
        this.menuAdminCollapsed = true;
      }
    },

    logout() {
      this.$store.dispatch("userLogout");
    },

    loadBranches() {
      this.selectedBranches = [];

      if (this.userRole == "employee" || this.userRole == "manager") {
        if (this.userBranches.length > 0) {
          this.selectedBranches = this.userBranches;
          this.countQueueClients();
          this.countPicturesOfToday();
        } 
      } else {
        db.collection("branches")
          .where("compId", "==", this.userCompany)
          .get()
          .then(snap => {
            snap.forEach(doc => {
              let branchCollection = doc.data();
              branchCollection.id = doc.id;
              this.selectedBranches.push(doc.id);
            });
          })
          .then(() => {
            this.countQueueClients();
            this.countPicturesOfToday();
          });
      }
    },
    
    countQueueClients(){
      let today = new Date()
        if (this.selectedBranches.length > 0) {
          let branchCounter = 0;
          this.clientQueue = []
          new Promise((resolve, reject) => {
            this.selectedBranches.forEach(branch => {
              db.collection("clientQueue")
                .where("queueEndDate",">", today)
                .where("branch", "==", branch)
                .where("deleted.deleted","==", false)
                .where("scheduled","==", false)
                .get()
                .then(snap => {
                  snap.forEach(doc => {
                    let client = doc.data();
                    this.clientQueue.push(client);
                  });
                })
                .then(() => {
                  branchCounter++;
                  if (branchCounter == this.selectedBranches.length) {
                    resolve();
                  }
                });
            })
          })
          .then(() => {
            if( this.clientQueue.length > 0){
              this.showBatchQueue = true
            } else{
              this.showBatchQueue = false
            }
          })
        } else {
          // console.log("Geen userBranches")
        } 
    },

    countPicturesOfToday(){
      let todayStart = moment().format("YYYY-MM-DD")
      let today = moment(todayStart).format("YYYY-MM-DDTHH:mm")
      if (this.selectedBranches.length > 0) {
        let branchCounter = 0;
        this.clientQueue = []
        new Promise((resolve, reject) => {
          this.selectedBranches.forEach(branch => {
            db.collection("clientphotos")
              .where("datePhoto",">", today)
              .where("branch", "==", branch)
              .get()
              .then(snap => {
                snap.forEach(doc => {
                  let photo = doc.data();
                  this.clientPhotos.push(photo);
                });
              })
              .then(() => {
                branchCounter++;
                if (branchCounter == this.selectedBranches.length) {
                  resolve();
                }
              });
          })
        })
        .then(() => {
          if( this.clientPhotos.length > 0){
            this.showBatchPhotos = true
          } else{
            this.showBatchPhotos= false
          }
        })
      } else {
        // console.log("Geen userBranches")
      } 
    },

  },
  computed: {

    companyType(){
      return this.$store.state.companyType
    },
    version() {
      return this.$store.state.version;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userAbb() {
      return this.$store.state.userAbb;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userBranches() {
      return this.$store.state.userBranches;
    }, 

    userPermissions() {
      return this.$store.state.userPermissions;
    },
    companyType() {
      return this.$store.state.companyType;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    companyPackages() {
      return this.$store.state.companyPackages;
    },
    companyTrials() {
      return this.$store.state.companyTrials;
    },
    companyNarrowcasting() {
      if (_.includes(this.companyPackages, "narrowcasting")) {
        return true;
      } else {
        return false;
      }
    },
    companyJourney() {
      if (_.includes(this.companyPackages, "customerjourney")) {
        return true;
      } else {
        return false;
      }
    },

    companyDossierPhotos() {
      if (_.includes(this.companyPackages, "dossierphotos")) {
        return true;
      } else {
        return false;
      }
    },

    companyDossier(){
      let active = false; 
      if( this.companyPackages && _.indexOf(this.companyPackages, 'dossier') >= 0){
        active = true;
      }
      else{
        // Package not purchased, check for active trial
        if(this.companyTrials && this.companyTrials.length > 0){
          this.companyTrials.forEach(trailPackage =>{
            if(trailPackage.id == 'dossier'){
              // Trial found, check if trialperiod is still active
              if(moment(trailPackage.trialStartDate).add(trailPackage.trialDays, 'days') > moment()){
                active = true;
              }
            }
          })
        }
      }
      return active
    },

    companySms(){
      if(this.companyPackages && _.indexOf(this.companyPackages, 'sms') >= 0){
        return true;
      }
      else{
        return false
      }
    },

    companyJourney(){
      let active = false; 

      if( this.companyPackages && _.indexOf(this.companyPackages, 'customerjourney') >= 0){
        active = true;
      }
      else{
        // Package not purchased, check for active trial
        if(this.companyTrials && this.companyTrials.length > 0){
          this.companyTrials.forEach(trailPackage =>{
            if(trailPackage.id == 'customerjourney'){
              // Trial found, check if trialperiod is still active
              if(moment(trailPackage.trialStartDate).add(trailPackage.trialDays, 'days') > moment()){
                active = true;
              }
            }
          })
        }
      }
      return active
    },

    companyConversion() {
      let active = false; 
      if (_.includes(this.companyPackages, "conversion")) {
        active = true;
      } 
      else{
        // Package not purchased, check for active trial
        if(this.companyTrials && this.companyTrials.length > 0){
          this.companyTrials.forEach(trailPackage =>{
            if(trailPackage.id == 'conversion'){
              // Trial found, check if trialperiod is still active
              if(moment(trailPackage.trialStartDate).add(trailPackage.trialDays, 'days') > moment()){
                active = true;
              }
            }
          })
        }
      }
    
      return active;
      
    },
    companyCallcenter() {
      if (this.$store.state.userRole == 'superadmin' || (_.includes(this.companyPackages, "callcenter" && (this.$store.state.userCallCenterCompanies && this.$store.state.userCallCenterCompanies.length > 0)))) {
        return true;
      } else {
        return false;
      }
    },

    userCompanyName(){
      return this.$store.state.userCompanyName;
    },

    companyBarometers() {
      if (_.includes(this.companyPackages, "barometers")) {
        return true;
      } else {
        return false;
      }
    },
    demoMode(){
      return this.$store.state.demoMode;
    }
  }
};
</script>


<style>

.menu-top {
  height: 47px;
  width: 100%;
  background-color: var(--v-background-base);
}

.menu-top-icon {
  padding: 14px 23px 0 23px;
  height: 44px;
}

.menu-mobile-header{
 font-weight: 600;
 font-size: 16px;
 padding: 5px 5px 5px 15px;
}

#menu-wrapper .menu-item {
  height: 44px;
  background: var(--v-menu-base);
  border-top: 1px solid var(--v-menuborder-base);
}

.menu-user-info{
  border-top: 1px solid var(--v-menuborder-base);
  padding: 0 10px;
  background-color: var(--v-menu-base);
}

.user-icon {
  float: left;
  width: 36px;
  height: 36px;
  border-radius: 40px;
  overflow: hidden;
  margin: 0 0 0 5px;
}

#menu-wrapper.menu-expanded .user-icon {
  width: 40px;
  height: 40px;
   margin: 0 10px 0 0;
}

.user-icon p {
  font-family: "Sofia Pro", sans-serif;
  font-size: 18px;
  text-align: center;
  text-transform: uppercase;
  padding: 6px 0 0 0;
  height: 36px;
}

#menu-wrapper.menu-expanded .user-icon p {
  font-size: 20px;
  padding: 8px 0 0 0;
  height: 40px;
}

.user-info{
  float: left;
  width: calc(100% - 60px);
  display: none;
}

#menu-wrapper.menu-expanded .user-info{
  display: block;
}

.user-info-name{
  font-weight: 600;
}
.menu-group{
  position: relative;
}

.menu-group.first{
  border-top: 1px solid var(--v-menuborder-base);
}

.menu-group{
  border-bottom: 1px solid var(--v-menuborder-base);
  background-color: var(--v-menuhover-base); 
}
.menu-group.small,
.menu-group.collapsed{
  background-color: var(--v-menu-base);
}
.menu-group-summary,
.menu-group.small .menu-group-summary,
#menu-wrapper.menu-expanded .menu-group.small .menu-group-summary{
  padding: 10px 0 10px 10px;
}

#menu-wrapper.menu-expanded .menu-group-summary{
  padding: 15px 10px;
}

.menu-group-summary-text{
  display: none;
}

#menu-wrapper.menu-expanded .menu-group-summary-text{
  display: block;
  width: 200px;
  height: 25px;
  float: left;
}

.menu-group-summary-icon i.v-icon{
  font-size: 22px!important;
}

#menu-wrapper.menu-expanded .menu-group-summary-icon i.v-icon{
  font-size: 18px!important;
}

.menu-group-summary:hover{
  background: var(--v-menuhover-base);
  cursor: pointer;
}

.menu-group-name{
  color: var(--v-text-base);
  font-weight: 600;
  font-size: 14px;
  margin: 0!important;
}

.menu-group .menu-group-summary-items{
  display: none;
}

.menu-group.collapsed .menu-group-summary-items{
  display: block;
  color: var(--v-text-base);
  font-weight: 400;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.menu-group-item,
.menu-group-summary:after{
  display: block;
  content:"";
  clear: both;
}

.menu-group-summary-icon{
  display: block;
  width: 25px;
  height: 25px;
  float: left;
  padding: 3px 0 0 0;
  margin: 0 0 0 12px;
}

#menu-wrapper.menu-expanded .menu-group-summary-icon{
  display: block;
  width: 25px;
  height: 25px;
  float: left;
  padding: 3px 0 0 0;
  margin: 0;
}

.menu-group.collapsed .menu-group-summary-text{
  height: 36px;
}

.menu-group-expand i.v-icon{
  font-size: 20px!important
}

#menu-wrapper.menu-expanded .menu-group-expand i.v-icon{
  font-size: 24px!important
}

.menu-group-expand{
  width: 20px;
  height: 25px;
  float: left;
  padding: 4px 2px 0 2px;
}

#menu-wrapper.menu-expanded .menu-group.collapsed .menu-group-expand{
  height: 36px;
}

.menu-group.collapsed .menu-group-items,
#menu-wrapper.menu-expanded .menu-group.collapsed .menu-group-items{
  display: none;
  height: 0;
  padding: 0;
}
.menu-group-items-wrapper{
  position: fixed;
}

#menu-wrapper.menu-expanded .menu-group-items-wrapper{
  position: relative;
}

.menu-group-items{
  position: absolute;
  height: auto;
  left: 80px;
  top: -45px;
  width: 250px;
  z-index: 999;
  background-color: var(--v-menu-base);
  text-overflow: ellipsis;
  white-space: nowrap;
  box-shadow: 0px 0px 15px rgba(0,0,0,0.1);;
}

.menu-group-items:before{
  position: absolute;
  display: block;
  left: -16px;
  content: "";
  top: 14px;
  height: 10px;
  width: 10px;
  border: 8px solid var(--v-menu-base);
  border-bottom-color: transparent;
  border-left-color: transparent;
  border-top-color: transparent;
 
}

#menu-wrapper.menu-expanded .menu-group-items{
  position: relative;
  height: auto;
  left: 0;
  top: 0;
  width: 100%;;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 0 15px 0;
  box-shadow: none;
}

#menu-wrapper.menu-expanded {
  width: 275px;
}

#menu-wrapper.menu-expanded .menu-group-items::before{
  display: none;
}

.menu-group-item{
  height: 32px;
  padding: 6px 0;
}

.menu-group-item:hover{
  background-color: var(--v-menuhover-base);
  cursor: pointer;
}
.menu-group-item.router-link-exact-active,
.menu-group.small.router-link-exact-active{
  background-color: var(--v-menuhover-base)
}

.menu-group-item .menu-item-icon{
  width: 40px;
  padding: 0 10px 0 15px;
  height: 20px;
  float: left;
}

.menu-group-item .menu-item-text{
  width: calc(100% - 40px);
  height: 20px;
  float: left;
  font-size: 14px;
  font-weight: 300;
  color: var(--v-text-base);
}

.custom-menu-icon{
  width: 18px;
  height: 18px;
}

.menu-user-info.router-link-exact-active{
  background-color: var(--v-menuhover-base);
}

.menu-user-info,
.menu-group,
.menu-group-items,
.menu-group-item,
.menu-item-text{
-webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently */
}

.nav-fixed-buttom{
  position: absolute;
  bottom: 0;
  height: 133px;
  width: 100%;
}
.nav-fixed-buttom.superadmin{
  height: 173px;
}

.nav-scroll{
  position: absolute;
  overflow-y: scroll;
  overflow-x: scroll;
  top: 47px;
  width: 100%;;
  height: calc(100% - 181px);
  padding: 0 0 15px 0;
}

.nav-scroll.superadmin{
  height: calc(100% - 221px);
}

.nav-scroll::-webkit-scrollbar {
    display: none;
}

.menu-group.small .menu-group-expand{
  display: none;
}

.logout{
  position: absolute;
  bottom: 0;
  width: 100%;
}

</style>

